<template>
  <Toast />
  <section>
    <base-card>
      <h2>Administracion Tipos de Viaje</h2>
      <TiposViajenewForm @save-data="saveData"></TiposViajenewForm
    ></base-card>
  </section>
</template>

<script>
import TiposViajenewForm from '../../components/tiposviaje/TiposViajenewForm.vue';

export default {
  components: {
    TiposViajenewForm,
  },
  data() {
    return { error: null };
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
  },
  methods: {
    handleError() {
      this.error = null;
    },

    removeItemFromArr(arr, item) {
      console.log(arr);
      var i = arr.indexOf(item);

      if (i !== -1) {
        arr.splice(i, 1);
      }
    },
    async saveData(data, dir) {
      console.log(data + dir);
      try {
        const response = await this.$store.dispatch('TiposViaje', data, 'POST');
        console.log(response);
        if (response[0].codigo == '00011') {
          this.$toast.add({
            severity: 'success',
            summary: 'Registro agreado ',
            detail: response[0].mensaje,
            //group: 'br',
            life: 2000,
          });
          setTimeout(() => {
            this.$router.replace('/tiposviaje');
          }, 2000);
        } else {
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: response[0].mensaje,
            //group: 'br',
            life: 2000,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
